<template>
    <div class="container-fluid">

        <div class="row">
            <div class="col-12">
                <form class="needs-validation form-style vs-con-loading__container" novalidate
                      @submit.prevent="onSubmit" id="div-with-loading">

<!--                    standardize the positioning // class=inputFile-box -->
                    <div class="row">

                        <div class="col-md-12">
                            <div style="margin-top: 20px;">
<!--                                <div v-if="selectedFile.length > 0 && isNull(post)" @click="clearPreview()"-->
<!--                                     style="margin-bottom: 20px; text-align: right;">-->
<!--                                    <button class="btn btn-primary">-->
<!--                                        <i class="fa fa-ban" aria-hidden="true"></i>-->
<!--                                        <span style="margin-left: 5px;">{{lang("Remove All")}}</span>-->
<!--                                    </button>-->
<!--                                </div>-->

                                <div class="upload-file-list-container">
                                    <div class="each-file-container"
                                         v-if="selectedFile != null && selectedFile.length > 0"
                                         v-for="(file, key) in selectedFile" :key="(file, key).id">
                                        <span class="each-file">
<!--                                            {{checkIfImage(file)}}-->
                                            <img v-if="checkIfImage(file)" class="preview" v-bind:ref="'image'+parseInt( key )"/>

                                            <div class="media-file-video preview" v-if="!checkIfImage(file) && file.type.toLowerCase() !== 'application/pdf'"
                                                 :class="'video-thumbnail-'+key" @click="triggerClickVideo(file, key)" v-bind:ref="'video'+parseInt( key )">
                                                <img class="preview" src="../assets/video-thumbnail.jpg" />
                                                <div class="lds-ellipsis" v-if="videoClick" style="top: 40%;">
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                </div>
                                            </div>

<!--                                            <video class="media-file-video preview" v-if="!checkIfImage(file) && file.type.toLowerCase() !== 'application/pdf'" controls-->
<!--                                                   style="max-width: 100%;" v-bind:ref="'video'+parseInt( key )" :type="file.type.toLowerCase()">-->
<!--&lt;!&ndash;                                                <source >&ndash;&gt;-->
<!--                                            </video>-->

                                            <pdf class="media-file-video preview" v-if="!checkIfImage(file) && file.type.toLowerCase() === 'application/pdf'"
                                                 style="max-width: 100%; overflow: auto;" v-bind:ref="'pdf'+parseInt( key )" :type="file.type.toLowerCase()"></pdf>
                                        </span>

<!--                                        <span v-if="isNull(post)" class="each-file-close" @click="removePreviewImg(file.name)" :id="(file, key).id"><strong>x</strong></span>-->
                                    </div>

                                    <div class="each-file-container" v-if="selectedFile.length <= 0">
                                        <div class="lds-ellipsis" v-if="!isLoad">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                    </div>

<!--                                    <div class="upload-file-box" id="upload-file-box">-->
<!--                                        <span style="display: inline-block;">Choose a file</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <input type="file" multiple @change="onFileChanged" ref="fileupload" class="inputfile"
                                   id="inputfile"
                                   data-multiple-caption="{count} files selected">
<!--                            <label for="inputfile">Choose a file</label>-->

<!--                            <div class="btn btn-primary" v-if="selectedFile" @click="clearPreview()"><strong>X</strong>-->
<!--                                REMOVE ALL-->
<!--                            </div>-->
<!--                            <div class="uploadFile-image">-->
<!--                                <div v-for="(file, key) in selectedFile" class="col-md-3 file-listing"-->
<!--                                     :key="(file, key).id"-->
<!--                                     v-if="checkIfImage(file)">-->
<!--                                    <img class="preview" v-bind:ref="'image'+parseInt( key )"/>-->
<!--                                    <span @click="removePreviewImg(file.name)" class="clearFile-single"><i class="el-icon-error"></i></span>-->
<!--                                </div>-->
<!--                                <div v-for="(file, key) in selectedFile" class="col-md-3 file-listing nonimg-uploadFile"-->
<!--                                     :key="(file, key).id"-->
<!--                                     v-if="!checkIfImage(file)">-->
<!--                                    <i class="el-icon-tickets"></i> {{ file.name }}-->
<!--                                    <span @click="removePreviewImg(file)" class="clearFile-single"><i class="el-icon-error"></i> </span>-->
<!--                                </div>-->
<!--                            </div>-->
                        </div>
                    </div>

                    <div class="mb-3 form-group" :class="{ 'form-group--error': $v.addPostContent.$error }">

<!--                        <div>-->
<!--                            <fieldset style="margin-bottom: 10px;">-->
<!--                                <el-button class="fontStyle" style="width: 30px; padding: 5px 10px;"-->
<!--                                           @click="inlineExecCommand('italic',false,null)"-->
<!--                                           title="Italicize Highlighted Text"><i>I</i>-->
<!--                                </el-button>-->
<!--                                <el-button class="fontStyle" style="width: 30px; padding: 5px 10px;"-->
<!--                                           @click="inlineExecCommand('bold',false,null)"-->
<!--                                           title="Bold Highlighted Text"><b>B</b>-->
<!--                                </el-button>-->
<!--                                <el-button class="fontStyle" style="width: 30px; padding: 5px 10px;"-->
<!--                                           @click="inlineExecCommand('underline',false,null)"-->
<!--                                           title="Underline Highlighted Text"><u>U</u>-->
<!--                                </el-button>-->
<!--                            </fieldset>-->

<!--                            <div class="form-control" contenteditable="true" id="postContent"-->
<!--                                 @input="updateInput"-->
<!--                                 @paste="pasteContent"-->
<!--                                 :placeholder="lang('Please enter your content here')"-->
<!--                                 style="min-height: 100px; overflow: auto; resize: vertical;">-->

<!--                            </div>-->

<!--                            <div class="error requiredFieldsMsg" v-if="!$v.addPostContent.required">-->
<!--                                <el-alert-->
<!--                                        :title="lang('Content is required')"-->
<!--                                        type="error">-->
<!--                                </el-alert>-->
<!--                            </div>-->
<!--                        </div>-->

                        <div>
                            <div class="post-content-editor-container" @paste="pasteContent">
                                <quill-editor
                                        ref="postContentEditor"
                                        v-model="addPostContent"
                                        :options="editorOption"
                                />
                            </div>

                            <div class="error requiredFieldsMsg" v-if="!$v.addPostContent.required">
                                <el-alert
                                        :title="lang('Content is required')"
                                        type="error">
                                </el-alert>
                            </div>
                        </div>

                        <!--<label for="username">Username</label>  style="resize: none;"-->
<!--                        <textarea type="text" class="form-control" id="postContent" v-model="addPostContent"-->
<!--                                  :placeholder="lang('Please enter your content here')" v-model.trim="$v.addPostContent.$model" ></textarea>-->
<!--                        <div class="error requiredFieldsMsg" v-if="!$v.addPostContent.required">-->
<!--                            <el-alert-->
<!--                                    :title="lang('Content is required')"-->
<!--                                    type="error">-->
<!--                            </el-alert>-->
<!--                        </div>-->
                    </div>

                    <div class="mb-3 form-group">
                        <label>{{lang('Hashtag')}}</label>
						<small>{{lang("Please type in your word without '#'. Add your tag one per line.")}}</small><br />
						<small style="color:red;">{{lang('* use hashtag moments or Moments for post to appear under parent Moments.')}}</small>
                        <div class="row col-md-12" style="padding: 0px;">
                            <el-input class="col-md-10" type="text" v-model="feedCaption"></el-input>
                            <div class="col-md-2" @click="addCaption">
                                <span class="btn btn-primary" style="cursor: pointer">{{lang("Add")}}</span>
                            </div>
                        </div>

                        <div style="margin-top: 10px;" v-if="arrobj_latestPostTag.length > 0">
                            <small style="display: block; margin-bottom: 10px;">{{lang("or select latest posted tags")}}</small>
                            <div v-for="latestTag in arrobj_latestPostTag" class="each-latest-post-tag"
                                 @click="addCaptionByLatest(latestTag.PostKeyTagValue)">
                                <span>{{latestTag.PostKeyTagValue}}</span>
                            </div>
                        </div>

                        <div>
                            <div v-if="arrobj_keyTag.length>0">
                                <data-tables :data="arrobj_keyTag" :action-col="arrobj_keyTagListAction">
                                    <el-table-column v-for="keyTag in arrobj_keyTagList" :prop="keyTag.prop"
                                                     :label="keyTag.label" :key="keyTag.prop"
                                                     sortable="custom">
                                    </el-table-column>
                                </data-tables>
                            </div>
                        </div>
                    </div>

<!--                    temporary hide-->
<!--                    <div class="mb-3 form-group">-->
<!--                        <el-checkbox v-model="isAllowComment">-->
<!--                            {{lang("Allow user comment")}}-->
<!--                        </el-checkbox>-->
<!--                    </div>-->

                    <!--<div class="row">
                        <div class="col-md-6 ">
                            <label :for="tagClassID">Class</label>
                            <select class="form-control" id="tagClassID" v-model="tagClassID">
                                <option v-for="object in classesTable" :key="object.PK_Class_ID"
                                        :value="object.PK_Class_ID">{{object.CLS_ClassName}}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label for="tagLevelID">Level</label>
                            <select class="form-control" id="tagLevelID" v-model="tagLevelID">
                                <option v-for="object in levelsTable" :key="object.PK_Class_ID"
                                        :value="object.SC_FK_CourseID">{{object.CRS_Course_Name}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label>Student</label>
                            <vue-tags-input
                                    v-model="tag"
                                    :tags="tags"
                                    :allow-edit-tags="true"
                                    :autocomplete-items="items"
                                    :add-only-from-autocomplete="true"
                                    :autocomplete-min-length="3"
                                    placeholder="Min 3 Character"
                                    class="tags-input"
                                    @tags-changed="newTags => tags = newTags"
                            />
                        </div>
                    </div>-->

                    <div>
                        <tags-component @tags="setTags" :parent_Post="post"></tags-component>

                        <div v-if="tags.length > 0 && currentPage === 'feed' && schUniversity === 'UTY201300000061'">
                            <label>{{lang("Developmental Goals")}}</label>

                            <div class="row col-md-12">
                                <div class="col-md-6 formDiv" style="padding-left: 0px; position: relative;">
                                    <el-select v-model="porDevelopmentDomain" placeholder="Select Domain"
                                               class="w-100" @change="loadIndicator(porDevelopmentDomain)">

                                        <el-option v-for="(item, index) in porDevelopmentDomainList"
                                                   class="ddlDevelopmentDomainOption"
                                                   :key="index"
                                                   :label="item.Str_SortBy"
                                                   :value="item.Str_SortBy">
                                        </el-option>
                                    </el-select>
                                </div>

                                <div class="col-md-6 formDiv" style="padding-left: 0px; position: relative;">
                                    <el-select v-model="porDevelopmentIndicator" placeholder="Select Indicator"
                                               class="w-100" @change="setValidateDropdown(porDevelopmentIndicator)" filterable>
                                        <el-option v-for="(item, index) in porDevelopmentIndicatorList"
                                                   class="ddlDevelopmentIndicatorOption"
                                                   :key="item.PlnStaIndicator.trim()"
                                                   :label="item.PlnStaIndicator.trim()"
                                                   :value="item.PlnStaIndicator.trim()">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div v-if="porDevelopmentObject.length>0" class="col-md-12 formDiv"
                                 style="margin-bottom: 20px; margin-top: 20px; padding: 0px;">
                                <label>{{lang("You have selected")}}</label>

                                <table class=" w-100">
                                    <thead class="table-thead">
                                    <tr class="table-tr">
                                        <th class="table-th">{{lang("Domain")}}</th>
                                        <th class="table-th">{{lang("Goals")}}</th>
                                        <th class="table-th">{{lang("Indicator")}}</th>
                                        <th class="table-th">{{lang("Action")}}</th>
                                    </tr>
                                    </thead>

                                    <tr v-for="(porDevelopmentObjectValueInfo, index) in porDevelopmentObject" style="border-bottom: 1px solid #e4e7ed;">
                                        <td class="table-td">{{porDevelopmentObjectValueInfo.Domain}}</td>
                                        <td class="table-td">{{porDevelopmentObjectValueInfo.Goals}}</td>
                                        <td class="table-td"><input type="text" class="form-control" readonly
                                                                    :value="porDevelopmentObjectValueInfo.Indicator"
                                                                    style="margin: 0px;" @blur="setAnalysisValue($event, index)" /></td>
                                        <td class="table-td" style="padding: 10px 0px; text-align: center;">
                                            <el-button @click="removeSelectedGoals(porDevelopmentObjectValueInfo, index)">
                                                {{lang("Delete")}}
                                            </el-button>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>

<!--                    <tags-component @tags="setTags" :parent_Post="post"></tags-component>-->
<!--                    <div class="row inputFile-box">-->
<!--                        <div class="col-md-12">-->
<!--                            <input type="file" multiple @change="onFileChanged" ref="fileupload" class="inputfile"-->
<!--                                   id="inputfile"-->
<!--                                   data-multiple-caption="{count} files selected">-->
<!--                            <label for="inputfile">Choose a file</label>-->

<!--                            <div class="btn btn-primary" v-if="selectedFile" @click="clearPreview()"><strong>X</strong>-->
<!--                                REMOVE ALL-->
<!--                            </div>-->
<!--                            <div class="uploadFile-image">-->
<!--                                <div v-for="(file, key) in selectedFile" class="col-md-3 file-listing"-->
<!--                                     :key="(file, key).id"-->
<!--                                     v-if="checkIfImage(file)">-->
<!--                                    <img class="preview" v-bind:ref="'image'+parseInt( key )"/>-->
<!--                                    <span @click="removePreviewImg(file.name)" class="clearFile-single"><i class="el-icon-error"></i></span>-->
<!--                                </div>-->
<!--                                <div v-for="(file, key) in selectedFile" class="col-md-3 file-listing nonimg-uploadFile"-->
<!--                                     :key="(file, key).id"-->
<!--                                     v-if="!checkIfImage(file)">-->
<!--                                    <i class="el-icon-tickets"></i> {{ file.name }}-->
<!--                                    <span @click="removePreviewImg(file)" class="clearFile-single"><i class="el-icon-error"></i> </span>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="mb-2">

                    </div>
                    <!--<div class="system-msg" v-bind:class="{'bg-danger': systemmsgError===true}">{{results}}-->
                    <!--<p v-if="error" style="color: red">{{error}}</p></div>-->
                    <div class="row d-flex  form-footer">
                        <div class="col-md-6">
                            <b-btn @click="resetAll" class="float-left btn-secondary">{{lang("Cancel")}}</b-btn>
                        </div>
                        <div class="col-md-6" style="text-align: right;">
                            <button class="btn btn-primary " type="submit" style="margin-right: 10px; display: inline-block;"
                                    @click="setStatus('Draft')">{{lang("Save as draft")}}
                            </button>

                            <button class="btn btn-primary " type="submit" style="display: inline-block;" @click="Validation">{{lang("Post")}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import VueTagsInput from '@johmun/vue-tags-input';
    import isImage from "is-image";
    import DataSource from "../data/datasource";
    import tagsComponent from "./Post_Tags_Component";
    // import tagsComponent from "./Feed_Tags_Component";
    import $j from "jquery";
    import {required} from "vuelidate/lib/validators";
    import {lang} from '../locale/index';
    import Cookies from "js-cookie";

    import { NotifEvent, notifGlobalVariable } from '../global/index.js';
    import pdf from 'vue-pdf';

    import Vue from 'vue';
    import VueQuillEditor from 'vue-quill-editor';

    import 'quill/dist/quill.core.css'; // import styles
    import 'quill/dist/quill.snow.css'; // for snow theme
    import 'quill/dist/quill.bubble.css'; // for bubble theme

    Vue.use(VueQuillEditor, /* { default global options } */);

    export default {
        name: "updatesComponent",
        data() {
            return {
                PostID: "",
                addPostContent: "",
                tagClassID: "",
                tagLevelID: "",
                classesTable: [],
                levelsTable: [],
                tag: '',
                tags: [],
                selectedFile: [],
                systemmsgError: false,
                error: "",
                results: "",
                academicYearTable: [],
                studentTable: [],
                loading: false,
                uploadedFiles: [],
                clickCount: 0,
                isAllowComment: false,

                arrobj_SelectedStudents: [],
                ddlGoalsList: [],
                porDevelopmentDomain: '',
                porDevelopmentDomainList: [],
                porDevelopmentIndicator: '',
                porDevelopmentIndicatorList: [],
                arr_indicatorList: [],
                porDevelopmentObject: [],
                porDevelopmentObjectValue: [
                    {
                        prop: "Domain",
                        label: lang("Domain")
                    }, {
                        prop: "Goals",
                        label: lang("Goals")
                    }, {
                        prop: "Indicator",
                        label: lang("Indicator")
                    }
                ],
                obj_Post: {
                    PostID: "",
                    PostPorDtlTitle: "",
                    PostPorDtlObservation: "",
                    PostPorDtlAnalysisReflection: "",
                    PostPorDtlDevelopmentGoals: []
                },
                ddlClass: '', // CLS201800024287
                currentPage: '',
                feedCaption: '',
                arrobj_keyTag: [],
                arrobj_keyTagList: [{
                    prop: "KeyTag",
                    label: lang('Hashtag')
                }],
                arrobj_keyTagListAction: {
                    label: lang('Delete'),
                    props: {
                        align: 'center',
                    },
                    buttons: [{
                        props: {
                            type: 'primary',
                            icon: 'el-icon-edit'
                        },
                        handler: row => {
                            this.arrobj_keyTag.splice(this.arrobj_keyTag.indexOf(row), 1)
                        },
                        label: lang('Delete')
                    }]
                },
                schUniversity: '',

                isLoad: false,
                videoClick: false,
                postStatus: "",

                arrobj_latestPostTag: [],

                editorOption: {
                    // Some Quill options...
                    theme: 'snow',
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'link'],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }]
                        ],
                    }
                },
            };
        },
        validations: {
            addPostContent: {
                required
            },
        },
        async created() {
            this.schUniversity = Cookies.get('userUniversitySession');
            await this.getLatestPostTag();
        },
        methods: {
            lang,
            sleep(milliseconds) {
                return new Promise(resolve => setTimeout(resolve, milliseconds));
            },
            //return a promise that resolves with a File instance
            urltoFile(url, filename, mimeType) {
                return (fetch(url)
                        .then(function (res) {
                            return res.arrayBuffer();
                        })
                        .then(function (buf) {
                            // console.log(buf, "buf");
                            return new File([buf], filename, {type: (mimeType === "audio/vnd.dlna.adts" ? "audio/aac" : mimeType)});
                        })
                );
            },
            isNull(obj) {
                return (obj === null || obj === undefined || obj === "undefined");
            },
            resetAll() {
                this.clearPreview();
                this.$emit("result", "CANCEL");
            },
            init() {
                DataSource.shared.getPostDropdown().then((tagResponse) => {
                    if (tagResponse.AcademicYearTable && tagResponse.AcademicYearTable.Table) {
                        let uniqueYears = [];
                        tagResponse.AcademicYearTable.Table.forEach(object => {
                            const isExist = uniqueYears.find(year => year.SMT_Code === object.SMT_Code);
                            if (!isExist) {
                                uniqueYears.push(object);
                            }
                        });
                        this.academicYearTable = uniqueYears;
                    }
                    if (tagResponse.ClassesTable && tagResponse.ClassesTable.Table) {
                        let uniqueClass = [];
                        tagResponse.ClassesTable.Table.forEach(object => {
                            const isExist = uniqueClass.find(year => year.PK_Class_ID === object.PK_Class_ID);
                            if (!isExist) {
                                uniqueClass.push(object);
                            }
                        });
                        this.classesTable = uniqueClass;
                    }
                    if (tagResponse.LevelsTable && tagResponse.LevelsTable.Table) {

                        let uniqueLevel = [];
                        tagResponse.LevelsTable.Table.forEach(object => {
                            const isExist = uniqueLevel.find(level => level.SC_FK_CourseID === object.SC_FK_CourseID);
                            if (!isExist) {
                                uniqueLevel.push(object);
                            }
                        });

                        this.levelsTable = uniqueLevel;
                    }
                    if (tagResponse.StudentTable && tagResponse.StudentTable.Table) {
                        let uniqueStudent = [];
                        tagResponse.StudentTable.Table.forEach(object => {
                            const isExist = uniqueStudent.find(student => student.Student_ID === object.Student_ID);
                            if (!isExist) {
                                const selectedValue = {
                                    Student_ID: object.Student_ID,
                                    text: object.Full_Name,
                                    Sex: object.Sex,
                                    // email: object.email,
                                    Status: object.Status
                                };
                                uniqueStudent.push(selectedValue);
                            }
                        });
                        // this.studentTable = tagResponse.StudentTable.Table;
                        this.studentTable = uniqueStudent;
                    }
                });
            },
            onFileChanged(event) {
                // this.selectedFile = event.target.files;
                for (let file of event.target.files) {
                    if (file.size > 10048576) {
                        this.$notify.error({
                            title: 'Error',
                            message: 'File limit exceeded 10MB!'
                        });
                    } else {
                        this.selectedFile.push(file);
                    }
                }
                // if (this.selectedFile.size > 5048576) {
                //     alert("File is too big!");
                //     this.selectedFile = "";
                // }
                this.getImagePreviews();
            },
            inputChange(input) {
                this.postContent = input;
            },
            checkIfImage(file) {
                const fileType = file.type.toLowerCase();
                switch (fileType) {
                    case "image/jpeg":
                    case "image/png":
                    case "image/jpg":
                    case "image/gif":
                        return true;
                    // case "video/mp4":
                    //     return "video/mp4";
                    default:
                        return false;
                }
            },
            isImageByExt(obj_File) {
                let ext = String(obj_File.PostItemFileExt).toUpperCase();
                let isImage = false;

                switch (ext) {
                    case ".PNG":
                    case ".JPG":
                    case ".BMP":
                    case ".GIF":
                    case ".JPEG":
                        isImage = true;
                        break;
                    default:
                        isImage = false;
                        break;
                }

                return isImage;
            },
            successMsg() {

            },
            errorMsg() {

            },
            Validation(){
                this.postStatus = "";
                this.$v.$touch();
            },
            async onSubmit() {
                if (!this.$v.$error) {
                    if (this.tags.length <= 0) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please Select Student'),
                        });
                        return;
                    } else {
                        this.error = "";
                        this.$vs.loading();
                        await this.sleep(500);
                        //this.results = "<< Requesting.. >>";
                        try {
                            /*const studentsIds = this.tags.map(d => d.Student_ID);*/
                            let allowComment = "";
                            if (this.isAllowComment) {
                                allowComment = "Yes";
                            } else {
                                allowComment = "No";
                            }

                            const saveResponse = await DataSource.shared.savePostUpdate(this.selectedFile, encodeURIComponent(this.addPostContent),
                                this.tags, this.tagClassID, this.tagLevelID, this.PostID, allowComment,
                                JSON.stringify(this.porDevelopmentObject), JSON.stringify(this.arrobj_keyTag), this.postStatus);
                            if (saveResponse) {

                                if (saveResponse.code == "1")
                                    this.$emit("result", "TRUE");
                                else
                                    this.$emit("result", "FALSE");
                                switch (saveResponse.code) {
                                    case "1":
                                        // this.$emit("notifChange");
                                        this.$emit("loadPosts");
                                        this.isModalOpen = false;
                                        // reset all input filed to blank
                                        this.selectedFile = [];
                                        this.$refs.fileupload.value = "";
                                        this.addPostContent = "";
                                        this.tagAcademicYearID = null;

                                        this.tagLevelID = null;
                                        this.tagClassID = null;
                                        this.results = `Post Submitted`;
                                        // this.success = '';
                                        this.$notify({
                                            title: lang('Success'),
                                            message: lang('Post Submitted, activity will be active in a while'),
                                            type: 'success'
                                        });
                                        await DataSource.shared.softDeletePost(this.PostID);

                                        this.$vs.loading.close();
                                        break;
                                    case "88":
                                        this.$vs.loading.close();
                                        this.$notify.error({
                                            title: lang('Error'),
                                            message: lang('Please Login to submit post')
                                        });
                                        this.systemmsgError = true;
                                        break;
                                    case "99":
                                        this.$vs.loading.close();
                                        this.$notify.error({
                                            title: lang('Error'),
                                            message: lang('Please fill in content')
                                        });
                                        this.systemmsgError = true;
                                        break;
                                    // default:
                                    //     alert("Please try again later");
                                    //     this.results = JSON.stringify(response);
                                }
                            }
                        } catch (e) {
                            console.log(e);
                            this.error = e;
                        }
                    }
                }
            },
            getImagePreviews() {
                /*
                  Iterate over all of the files and generate an image preview for each one.
                */
                for (let i = 0; i < this.selectedFile.length; i++) {
                    /*
                      Ensure the file is an image file
                    */
                    if (/\.(jpe?g|png|gif)$/i.test(this.selectedFile[i].name)) {
                        /*
                          Create a new FileReader object
                        */
                        let reader = new FileReader();

                        /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */

                        reader.addEventListener("load", function () {
                            this.$refs['image' + parseInt(i)][0].src = reader.result;
                        }.bind(this), false);

                        /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
                        reader.readAsDataURL(this.selectedFile[i]);
                    }

                    if (/\.(mp4|mp3|aac|wav|m4a|mov)$/i.test(this.selectedFile[i].name)) {
                        /*
                          Create a new FileReader object
                        */
                        let reader = new FileReader();
                        /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
                        reader.addEventListener("load", function () {
                            // this.$refs['video' + parseInt(i)][0].src = reader.result;
                            // this.$refs['video' + parseInt(i)][0].src = this.selectedFile[i].oriPath;
                        }.bind(this), false);

                        /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
                        reader.readAsDataURL(this.selectedFile[i]);
                    }

                    if (/\.(doc?x)$/i.test(this.selectedFile[i].name)) {
                        /*
                          Create a new FileReader object
                        */
                        let reader = new FileReader();

                        /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
                        reader.addEventListener("load", function () {
                            this.$refs['image' + parseInt(i)][0].src = "../assets/docx-icon.png";
                        }.bind(this), false);

                        /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
                        reader.readAsDataURL(this.selectedFile[i]);
                    }

                    if (/\.(xls?x)$/i.test(this.selectedFile[i].name)) {
                        /*
                          Create a new FileReader object
                        */
                        let reader = new FileReader();

                        /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
                        reader.addEventListener("load", function () {
                            this.$refs['image' + parseInt(i)][0].src = "../assets/excel-icon.png";
                        }.bind(this), false);

                        /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
                        reader.readAsDataURL(this.selectedFile[i]);
                    }

                    if (/\.(pdf)$/i.test(this.selectedFile[i].name)) {
                        /*
                          Create a new FileReader object
                        */
                        let reader = new FileReader();

                        /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
                        reader.addEventListener("load", function () {
                            this.$refs['pdf' + parseInt(i)][0].src = reader.result;
                        }.bind(this), false);

                        /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
                        reader.readAsDataURL(this.selectedFile[i]);
                    }
                }
            },
            clearPreview() {
                $j("#inputfile").val("");
                this.selectedFile = [];
            },
            removePreviewImg(fileName) {

                this.selectedFile = this.selectedFile.filter(d => {
                    return d.name !== fileName;
                });

                this.getImagePreviews()
            },
            setTags(value) {
                this.tags = value;

                // this.arrobj_SelectedStudents = [];
                // // this.tags = value;
                // this.tags = [];
                //
                // if (!this.isNull(value)) {
                //     value.forEach(m => {
                //         if (m.Student_ID) {
                //             this.arrobj_SelectedStudents.push(m.Student_ID);
                //             this.ddlClass = m.PK_Class_ID;
                //         }
                //         else {
                //             this.arrobj_SelectedStudents.push(m);
                //         }
                //     });
                // }
                //
                // this.tags = this.arrobj_SelectedStudents;
                //
                // // this.arrobj_SelectedStudents = value;
                if (this.tags.length > 0) {
                    this.getPlannerAssignedStudentsGroupByClassID(this.tags);
                } else {
                    this.arr_indicatorList = [];
                    this.porDevelopmentObject = [];
                    this.porDevelopmentIndicator = [];
                }

            },

            isMedia(ext) {
                ext = String(ext).toUpperCase();
                let isMedia = false;

                switch (ext) {
                    case ".PDF":
                    case ".MP4":
                    case ".MP3":
                    case ".AAC":
                    case ".WAV":
                    case ".M4A":
                    case ".MOV":
                        isMedia = true;
                        break;
                    default:
                        isMedia = false;
                        break;
                }

                return isMedia;
            },

            async getPlannerAssignedStudentsGroupByClassID(studentID) {
                try {
                    if (studentID === '') {
                        const response = await DataSource.shared.getPlannerAssignedStudentsGroupByClassID(this.ddlClass, '');

                        if (response) {
                            if (response.code === '88') {
                                window.location.replace('/');
                            } else if (response.code === '99') {
                                console.log('getPlannerAssignedStudentsGroupByClassID Error');
                            } else if (response.code === '2') {
                                this.obj_Post.PostPorDtlDevelopmentGoals = [];
                                this.ddlGoalsList = [];
                            } else {
                                this.obj_Post.PostPorDtlDevelopmentGoals = [];
                                this.ddlGoalsList = response.Table;
                            }
                        }
                    } else {
                        // //reset all to No
                        // this.ddlGoalsList = this.ddlGoalsList.map(m=> {
                        //     m.Included = 'No';
                        //     return m;
                        // });
                        // //reset all to No

                        let StudentIDList = [];

                        studentID.forEach(item => {
                            let tempStudentIDList = {
                                StudentID: item,
                            };

                            StudentIDList.push(tempStudentIDList);
                        });

                        if (StudentIDList.length > 0){
                            const response = await DataSource.shared.getPlannerAssignedStudentsGroupByClassID(this.ddlClass, JSON.stringify(StudentIDList));

                            if (response) {
                                if (response.code === '88') {
                                    window.location.replace('/');
                                } else if (response.code === '99') {
                                    console.log('getPlannerAssignedStudentsGroupByClassID Error');
                                } else if (response.code === '2') {
                                    console.log('getPlannerAssignedStudentsGroupByClassID no record');
                                } else {
                                    // //set those available to Yes
                                    // response.Table.forEach(item => {
                                    //     this.ddlGoalsList = this.ddlGoalsList.map(m=> {
                                    //         if (m.PlnStaIndicator === item.PlnStaIndicator) {
                                    //             m.Included = 'Yes';
                                    //         }
                                    //         return m;
                                    //     });
                                    // });
                                    // //set those available to Yes

                                    this.obj_Post.PostPorDtlDevelopmentGoals = [];
                                    this.ddlGoalsList = response.Table;
                                }
                            }
                        }
                    }

                    this.ddlGoalsList.forEach((goal, gIndex) => {
                        goal.KeyId = (gIndex+1);
                    });

                    this.loadDomainList();
                } catch (e) {
                    this.results = e;
                }
            },

            loadDomainList() {
                let sortedList = this.groupBy(this.ddlGoalsList, "PlnStaDomain");

                this.porDevelopmentDomainList = [];

                sortedList.forEach(item => {
                    this.porDevelopmentDomainList.push(item);
                });
            },

            groupBy(data, key) {
                let ArrObj_Sorted = [];

                for (let item of data) {
                    let index = ArrObj_Sorted.findIndex(x => x.Str_SortBy === item[key]);

                    if (index === -1) {
                        ArrObj_Sorted.push({Str_SortBy: item[key], ArrObj_Items: [item]});
                    } else
                        ArrObj_Sorted[index].ArrObj_Items.push(item);
                }

                return ArrObj_Sorted;
            },

            loadIndicator(value) {
                this.porDevelopmentIndicatorList = [];

                this.porDevelopmentDomainList.forEach(item => {
                    if (item.Str_SortBy === value) {
                        this.porDevelopmentIndicatorList = item.ArrObj_Items;
                    }
                });
            },

            setValidateDropdown(value) {

                if (this.porDevelopmentIndicator !== "") {
                    if (!this.arr_indicatorList.includes(this.porDevelopmentIndicator)) {
                        this.arr_indicatorList.push(this.porDevelopmentIndicator);
                    }
                }
                this.porDevelopmentObject = [];
                this.obj_Post.PostPorDtlAnalysisReflection = "";

                this.arr_indicatorList.forEach((indicator, iIndex) => {
                    this.ddlGoalsList.forEach(m => {
                        if (indicator === m.PlnStaIndicator) {
                            let porDevelopmentObjectTemp = {
                                Domain: m.PlnStaDomain,
                                Goals: m.PlnStaGoals,
                                Indicator: m.PlnStaIndicator,
                                KeyId: m.KeyId,
                            };

                            this.porDevelopmentObject.push(porDevelopmentObjectTemp);

                            this.obj_Post.PostPorDtlAnalysisReflection += m.PlnStaIndicator + '\n';
                        }
                    });
                });

                this.porDevelopmentDomain = "";
                this.porDevelopmentIndicator = "";
                this.porDevelopmentIndicatorList = [];

                this.loadDomainList();
            },

            removeSelectedGoals(itemValue, itemIndex) {
                this.ddlGoalsList.forEach((d, dIndex) => {
                    if (itemValue.KeyId === d.KeyId) {
                        this.arr_indicatorList = this.arr_indicatorList.filter((indicator, iIndex) => {
                            return indicator !== d.PlnStaIndicator;
                        });
                    }
                });

                this.setValidateDropdown(this.ddlGoalsList);
            },

            setAnalysisValue(event, objIndex) {

                let editedText = "";
                if (!this.isNull(event)) {
                    editedText = event.target.value;
                }

                this.obj_Post.PostPorDtlAnalysisReflection = "";

                this.porDevelopmentObject.forEach((val, index) => {
                    if (objIndex !== "" && index === objIndex && val.Indicator !== editedText) {
                        val.Indicator = editedText;

                        this.arr_indicatorList[objIndex] = editedText;

                        let porDevelopmentObjectTemp = {
                            PlnStaDomain: val.Domain,
                            PlnStaGoals: val.Goals,
                            PlnStaIndicator: val.Indicator,
                            Included: "No",
                            KeyId: (this.ddlGoalsList.length+1),
                        };

                        this.ddlGoalsList.push(porDevelopmentObjectTemp);
                    }
                    this.obj_Post.PostPorDtlAnalysisReflection += val.Indicator + '\n';
                });

                this.setValidateDropdown();
            },

            addCaption() {
                if (this.feedCaption !== "") {
                    var objKeyTag = {};
                    objKeyTag.KeyTag = this.feedCaption;
                    this.arrobj_keyTag.push(objKeyTag);

                    this.feedCaption = "";
                }
            },

            updateInput (e) {
                this.addPostContent = e.target.innerHTML;
            },

            pasteContent(e) {
                e.preventDefault();
                e.stopPropagation();
                // // Get the clipboard data
                let paste = (e.clipboardData || window.clipboardData).getData('text/plain');
                //
                // // Do something with paste like remove non-UTF-8 characters
                // paste = paste.replace(/\x0D/gi, "\n");
                // e.target.textContent += paste;

                document.execCommand("insertText", false, paste);
            },

            inlineExecCommand(type, bType, tNull) {
                document.execCommand(type, bType, tNull);
            },

            triggerClickVideo(videoFile, itemID) {
                if ($(".video-thumbnail-"+itemID+" img").length > 0) {
                    this.videoClick = true;
                    $(".video-thumbnail-"+itemID+" img").remove();

                    var videoHtml = "";
                    videoHtml += "<video class='media-file-video preview' style='max-width: 100%; height: 100%;' controls autoplay src='"+videoFile.oriPath+"' type='video/mp4' controlsList='nodownload'>";
                    // videoHtml += "<source :src='"+videoFile.FilePath+"' type='video/mp4'>";
                    videoHtml += "</video>";

                    if ($(".video-thumbnail-"+itemID+" video").length <= 0) {
                        $(".video-thumbnail-"+itemID).append(videoHtml);
                        this.videoClick = false;
                    }
                }
            },

            setStatus(val) {
                this.postStatus = val;
            },

            async getLatestPostTag() {
                // getUserLatestGroupPostKeyTag
                try {
                    const response = await DataSource.shared.getUserLatestGroupPostKeyTag(10);

                    if (response) {
                        if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            console.log('getUserLatestGroupPostKeyTag Error');
                        } else if (response.code === '2') {
                            this.arrobj_latestPostTag = [];
                        } else {
                            this.arrobj_latestPostTag = response.Table;
                        }
                    }
                } catch (e) {
                    // this.results = e;
                    console.log(e, "latest post tag error!");
                }
            },

            addCaptionByLatest(val) {
                var objKeyTag = {};
                objKeyTag.KeyTag = val;
                this.arrobj_keyTag.push(objKeyTag);
            },
        },
        async mounted() { // still need to addon (audio & video)
            // this.init();

            this.currentPage = this.paramCurrentPage;

            if (!this.isNull(this.post)) {
                this.currentPage = "feed";

                this.addPostContent = this.post.PostContent;
                $j("#postContent").html(this.post.PostContent);

                this.isAllowComment = false;
                if (this.post.PostAllowComment === "Yes") {
                    this.isAllowComment = true;
                }

                if (!this.isNull(this.post.postKeyTag) && this.post.postKeyTag.length > 0) {
                    this.arrobj_keyTag = [];
                    this.post.postKeyTag.forEach(item => {
                        var objKeyTag = {};
                        objKeyTag.KeyTag = item.PostKeyTagValue;
                        this.arrobj_keyTag.push(objKeyTag);
                    });
                }

                if (!this.isNull(this.post.postDevelopment) && this.post.postDevelopment.length > 0) {
                    this.porDevelopmentObject = [];
                    this.arr_indicatorList = [];
                    this.post.postDevelopment.forEach( (item, iIndex) => {
                        let porDevelopmentObjectTemp = {
                            Domain: item.PostUpLMDomain,
                            Goals: item.PostUpLMGoals,
                            Indicator: item.PostUpLMIndicator,
                            KeyId: (iIndex + 1),
                        };

                        this.arr_indicatorList.push(item.PostUpLMIndicator);
                        this.porDevelopmentObject.push(porDevelopmentObjectTemp);
                    });
                }

                // if (!this.isNull(this.post.arrobj_SelectedStudents) && this.post.arrobj_SelectedStudents.length > 0) {
                //     this.tags = [];
                //
                //     this.post.arrobj_SelectedStudents.forEach(m => {
                //         this.arrobj_SelectedStudents.push(m.PostTagUserID);
                //         this.ddlClass = m.PK_Class_ID;
                //     });
                //
                //     this.tags = this.arrobj_SelectedStudents;
                // }

                this.PostID = this.post.PostID;
                if (!this.isNull(this.post.postFiles)) {
                    this.selectedFile = [];
                    for (let image of this.post.postFiles) {
                        // console.log(image);
                        // let url = "data:" + image.PostItemFileType + ";base64," + image.PostItemFileLow;
                        // let url = "data:" + image.PostItemFileType + ";base64," + image.PostItemFile;
                        let url = image.FilePath;
                        let fileName = image.ID + '-image' + image.PostItemFileExt;
                        let mimeType = image.PostItemFileType;
                        await this.urltoFile(url, fileName, mimeType).then((file) => {
                            file.oriPath = url;
                            this.selectedFile.push(file);
                        }).finally(() => {
                            this.isLoad = true;
                            this.getImagePreviews();
                        });
                    }
                }
                /*this.selectedFile = ()=>{
                    let tempselectedFile = [];
                    for (let image of this.post.postFiles) {
                        let url = "data:" + image.GalFileType + ";base64," + image.GalFileLow;
                        let fileName = image.GalFileName + image.GalFileExt;
                        let mimeType = image.GalFileType;
                        this.urltoFile(url, fileName, mimeType).then((file) => {
                            tempselectedFile.push(file)
                        }).finally(() => {
                            return tempselectedFile;
                        });
                    }
                };*/
            }

            if (!this.isNull(this.images)) {

                this.selectedFile = [];
                for (let image of this.images) {
                    // let url = "data:" + image.GalFileType + ";base64," + (!this.isMedia(image.GalFileExt) ? image.GalFileLow : image.GalFile);
                    // let url = "data:" + image.GalFileType + ";base64," + image.GalFile;
                    let url = image.FilePath;
                    let fileName = image.GalFileName + image.GalFileExt;
                    let mimeType = image.GalFileType;

                    await this.urltoFile(url, fileName, mimeType).then((file) => {
                        file.oriPath = url;
                        this.selectedFile.push(file);
                    }).finally(() => {
                        this.isLoad = true;
                        this.getImagePreviews();
                    });
                }
            }

            // const self = this;
            $j("#upload-file-box").off("click").on("click", function (e) {
                // self.onFileChanged(e);
                $j("#inputfile").click();
            });
        },
        computed: {
            items() {
                return this.studentTable.filter(i => {
                    return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                });
            },
        },
        components: {
            /*VueTagsInput,*/
            tagsComponent,
            pdf,
        },
        props: ["images", "post", "notifChange", "paramCurrentPage"],
        watch: {
            paramCurrentPage: function(newVal, oldVal) { // watch it

                this.currentPage = oldVal;

                if (newVal && newVal !== oldVal) {
                    this.currentPage = newVal;
                }
            }
        },
    };
</script>

<style scoped>
    .upload-file-list-container {
        display: inline-block;
        margin-bottom: 20px;
    }

    .each-file-container {
        display: inline-block;
        height: 200px;
        width: 200px;
        vertical-align: top;
        margin: 0 20px 20px 0;
        border: 1px solid #ccc;
        border-radius: 8px;
        position: relative;
    }

    .each-file-container .each-file {
        display: block;
        height: 100%;
        width: 100%;
    }

    .each-file-container span img {
        /*object-fit: cover;*/
        width: 100%;
        height: 100%;
        border-radius: 6px;

        padding: 10px;
        object-fit: contain;
        /*background: #ccc;*/
    }

    .upload-file-box {
        width: 200px;
        height: 200px;
        border: 1px solid #ccc;
        border-radius: 8px;
        text-align: center;
        display: inline-block;
        cursor: pointer;
        padding: 80px 0;
    }

    .each-file-close {
        position: absolute;
        top: -15px;
        right: -5px;
        background: white;
        width: 30px;
        height: 30px;
        padding: 0 10px;
        border-radius: 50%;
        border: 1px solid #ccc;
        display: block;
        cursor: pointer;
    }

    .media-file-video {
        max-width: 100%;
        height: 100%;
        padding: 10px;
        border-radius: 6px;
        object-fit: contain;
    }

    .each-latest-post-tag {
        display: inline-block;
        margin-right: 15px;
        margin-bottom: 10px;
        border: 1px solid #0a74b7;
        padding: 0px 10px;
        text-align: center;
        border-radius: 3px;
        cursor: pointer;
        font-size: 14px;
        color: #0a74b7;
    }
</style>

<style>
    .post-content-editor-container .ql-editor {
        min-height: 150px;
        color: #495057;
        max-height: 150px;
        overflow: auto;
    }
</style>